// extracted by mini-css-extract-plugin
export default {"products":"RelatedProducts_products__lXbpz","product":"RelatedProducts_product__vjDCj","prodLink":"RelatedProducts_prodLink__7y62M"};